var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { staticClass: "ma-0 pa-0 pt-2 pb-2", attrs: { cols: "12" } },
        [
          _c(
            "v-row",
            { staticClass: "ma-0 pb-2", attrs: { align: "center" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 text-left",
                  class: {
                    "text-decoration-underline":
                      _vm.item.status === "COMPLETED",
                    download: _vm.item.status === "COMPLETED",
                  },
                  attrs: { cols: "4" },
                  on: {
                    click: function ($event) {
                      return _vm.download(_vm.item)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.getDownloadFileNameStatus()) + " ")]
              ),
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0 text-left", attrs: { cols: "4" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.item.beginTime.replace("T", " ").substring(0, 16) +
                          " ~ " +
                          _vm.item.endingTime.replace("T", " ").substring(0, 16)
                      ) +
                      " "
                  ),
                ]
              ),
              _vm.item.status === "COMPLETED" || _vm.item.status === "FAILED"
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 text-left",
                      attrs: { cols: "4" },
                    },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { align: "center" },
                        },
                        [
                          _vm.item.status === "COMPLETED"
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 text-left",
                                  attrs: { cols: "8" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.item.expiredTime
                                        .replace("T", " ")
                                        .substring(0, 16)
                                    )
                                  ),
                                ]
                              )
                            : _c("v-col", {
                                staticClass: "ma-0 pa-0 text-left",
                                attrs: { cols: "8" },
                              }),
                          _vm.item.status === "COMPLETED"
                            ? _c(
                                "v-col",
                                {
                                  staticClass:
                                    "ma-0 pa-0 text-left text-decoration-underline share_btn",
                                  attrs: { cols: "2" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onClickShare(_vm.item)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.tmb("titleShare")))]
                              )
                            : _c("v-col", {
                                staticClass:
                                  "ma-0 pa-0 text-left text-decoration-underline share_btn",
                                attrs: { cols: "2" },
                              }),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 text-left",
                              attrs: { cols: "2" },
                            },
                            [
                              _vm.item.status === "COMPLETED" ||
                              _vm.item.status === "FAILED"
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        id: "back_clean_btn",
                                        width: "2.5rem",
                                        height: "2.5rem",
                                        elevation: "0",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onClickDelete(_vm.item)
                                        },
                                      },
                                    },
                                    [
                                      _c("v-img", {
                                        staticClass: "ma-0 pa-0",
                                        attrs: {
                                          "max-height": "3rem",
                                          "max-width": "3rem",
                                          src: require("@/assets/images/close_round.png"),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("v-divider", {
            staticClass: "border-opacity-100",
            attrs: { color: "white" },
          }),
        ],
        1
      ),
      _c("DownloadShareDialog", {
        attrs: {
          dialogVisible: _vm.downloadShareDialogVisible,
          item: _vm.currentItem,
        },
        on: { visible: _vm.downloadShareDialogVisibleFunc },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }